import { gql } from "@apollo/client";

export const INVITE_ORGANIZATION = gql`
  mutation InviteOrganization($email: String!) {
    admin {
      inviteOrganization(email: $email)
    }
  }
`;
